<template>
  <div>
    <div class="parent">
      <v-card>
        <v-card-title class="info-title" @click="$emit('clicked', index)">
          <font-awesome-icon
            class="collapse"
            :icon="selected ? 'angle-down' : 'angle-left'"
          />
          <div class="text-center text-padding">
            {{ item.StrState }}
          </div>
        </v-card-title>
        <div>
          <app-row
            icon="question-circle"
            title="درخواست:"
            :value="item.NKMorkhasiCycle"
          />
        </div>
        <div v-if="selected">
          <app-row
            icon="hashtag"
            title="شناسه درخواست:"
            :value="item.Fserial"
          />
          <app-row
            icon="calendar-alt"
            title="تاریخ درخواست:"
            :value="item.DDate"
          />
          <div style="padding: 15px">
            <v-row align="center">
              <v-col class="d-flex">
                <b>توضیحات طلبه:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                <span v-html="item.StudentComment"></span>
                <a
                  class="innerLink"
                  v-if="item.HasStudentFile"
                  @click="
                    $emit('callDownload', {
                      index: item.Fserial,
                      token: item.HashToken,
                    })
                  "
                  >دریافت پیوست</a
                >
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>نظر مدرسه:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                {{ item.SchoolState }}.
                <span v-html="item.SchoolComment"></span>
                {{ item.SchoolMorkhasiCycle }}
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="d-flex">
                <b>نظر اداره آموزش مرکز:</b>
              </v-col>
            </v-row>
            <v-row align="center">
              <v-col class="content">
                {{ item.AmoozeshState }}.
                <span v-html="item.AmoozeshComment"></span>
                {{ item.AmoozeshMorkhasiCycle }}
              </v-col>
            </v-row>
            <v-row v-if="item.Removeable" class="ltr">
              <v-btn
                color="red white--text"
                class="register"
                rounded
                @click="$emit('removeRequest', item.Fserial)"
              >
                حذف درخواست
              </v-btn>
            </v-row>
            <div style="padding: 5px"></div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import DetailRow from "@/components/DetailRow";
export default {
  props: ["item", "index", "selectedItem"],
  computed: {
    selected() {
      return this.selectedItem == this.index;
    },
    dateRange() {
      return "از " + this.item.AzTarikh + " تا " + this.item.TaTarikh;
    },
  },
  components: {
    appRow: DetailRow,
  },
};
</script>
<style scoped>
.register {
  margin: 20px 20px 0 20px !important;
}
</style>
